export default __webpack_public_path__ + "static/media/profit.627a2115.svg";